import Promotion from "./Promotion";

export default Promotion;
